var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagKeysLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1305",
    "data-name": "Group 1305",
    xmlns: "http://www.w3.org/2000/svg",
    width: 354,
    height: 75,
    viewBox: "0 0 354 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2679",
    "data-name": "Rectangle 2679",
    fill: "#f5f6f7",
    stroke: "#eff1f2",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 354,
    height: 75,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 353.5,
    height: 74.5,
    rx: 7.75,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300",
    transform: "translate(-493.16 -937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1276",
    "data-name": "Group 1276",
    transform: "translate(596 986) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2680",
    "data-name": "Rectangle 2680",
    width: 25,
    height: 25,
    rx: 4,
    transform: "translate(-0.16 -1)",
    fill: "#5f7c9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M6,3,0,0V6Z",
    transform: "translate(9.84 8.5)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295",
    transform: "translate(762 986) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1293-2",
    "data-name": "Group 1293",
    transform: "translate(-0.16 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2680-2",
    "data-name": "Rectangle 2680",
    width: 25,
    height: 25,
    rx: 4,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2679-2",
    "data-name": "Rectangle 2679",
    width: 131,
    height: 25,
    rx: 4,
    transform: "translate(732.16 987) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M-26.346-6.228c0-.648.528-1.056,1.3-1.056a2.458,2.458,0,0,1,1.7.756.166.166,0,0,0,.252-.024l.492-.576a.174.174,0,0,0,0-.252A3.362,3.362,0,0,0-25.074-8.5a2.338,2.338,0,0,0-2.532,2.244c0,2.736,4.092,2.208,4.092,3.948,0,.708-.636,1.224-1.536,1.224a2.719,2.719,0,0,1-1.92-.876.179.179,0,0,0-.264-.012l-.54.576a.171.171,0,0,0-.024.24,3.33,3.33,0,0,0,2.736,1.3A2.614,2.614,0,0,0-22.23-2.268C-22.23-5.148-26.346-4.512-26.346-6.228ZM-17.79-6a2.324,2.324,0,0,0-1.932.984L-19.77-5.7a.177.177,0,0,0-.18-.18h-.78a.17.17,0,0,0-.18.18V2.1a.17.17,0,0,0,.18.18h.9a.17.17,0,0,0,.18-.18V-.78a2.322,2.322,0,0,0,1.86.864,2.887,2.887,0,0,0,2.868-3.012A2.911,2.911,0,0,0-17.79-6Zm-.12,4.932A1.774,1.774,0,0,1-19.686-2.94,1.815,1.815,0,0,1-17.91-4.86a1.8,1.8,0,0,1,1.776,1.92A1.781,1.781,0,0,1-17.91-1.068ZM-8.022-5.88H-8.8a.177.177,0,0,0-.18.18l-.048.684A2.324,2.324,0,0,0-10.962-6,2.911,2.911,0,0,0-13.83-2.928,2.887,2.887,0,0,0-10.962.084a2.326,2.326,0,0,0,1.92-.936l.06.672A.177.177,0,0,0-8.8,0h.78a.17.17,0,0,0,.18-.18V-5.7A.17.17,0,0,0-8.022-5.88Zm-2.82,4.812A1.781,1.781,0,0,1-12.618-2.94a1.8,1.8,0,0,1,1.776-1.92A1.815,1.815,0,0,1-9.066-2.94,1.774,1.774,0,0,1-10.842-1.068Zm7.32-.012A1.78,1.78,0,0,1-5.3-2.952a1.787,1.787,0,0,1,1.776-1.9,2.005,2.005,0,0,1,1.44.636c.1.084.18.1.264.012l.528-.5a.174.174,0,0,0,.012-.252A2.964,2.964,0,0,0-3.534-6,2.969,2.969,0,0,0-6.51-2.952,2.974,2.974,0,0,0-3.534.084,3,3,0,0,0-1.242-.96a.174.174,0,0,0-.012-.252l-.528-.5a.17.17,0,0,0-.264,0A1.939,1.939,0,0,1-3.522-1.08ZM2.622-6A2.917,2.917,0,0,0-.294-2.964,2.961,2.961,0,0,0,2.742.084a3.023,3.023,0,0,0,2.184-.9.168.168,0,0,0,0-.276l-.384-.372c-.084-.084-.156-.06-.252.012a2.226,2.226,0,0,1-1.428.48A1.788,1.788,0,0,1,.954-2.484H5.022c.324,0,.384-.216.384-.66A2.756,2.756,0,0,0,2.622-6Zm.012,1.092A1.62,1.62,0,0,1,4.29-3.36H.942A1.668,1.668,0,0,1,2.634-4.908ZM13.206-6a2.315,2.315,0,0,0-1.86.9V-8.58a.17.17,0,0,0-.18-.18h-.9a.17.17,0,0,0-.18.18v8.4a.17.17,0,0,0,.18.18h.78a.177.177,0,0,0,.18-.18l.06-.672a2.326,2.326,0,0,0,1.92.936,2.887,2.887,0,0,0,2.868-3.012A2.911,2.911,0,0,0,13.206-6Zm-.12,4.932A1.774,1.774,0,0,1,11.31-2.94a1.815,1.815,0,0,1,1.776-1.92,1.8,1.8,0,0,1,1.776,1.92A1.781,1.781,0,0,1,13.086-1.068ZM22.974-5.88h-.78a.177.177,0,0,0-.18.18l-.048.684A2.324,2.324,0,0,0,20.034-6a2.911,2.911,0,0,0-2.868,3.072A2.887,2.887,0,0,0,20.034.084a2.326,2.326,0,0,0,1.92-.936l.06.672a.177.177,0,0,0,.18.18h.78a.17.17,0,0,0,.18-.18V-5.7A.17.17,0,0,0,22.974-5.88Zm-2.82,4.812A1.781,1.781,0,0,1,18.378-2.94a1.8,1.8,0,0,1,1.776-1.92A1.815,1.815,0,0,1,21.93-2.94,1.774,1.774,0,0,1,20.154-1.068Zm7.98-4.716a1.22,1.22,0,0,0-.744-.228,1.684,1.684,0,0,0-1.476.888L25.866-5.7a.177.177,0,0,0-.18-.18h-.84a.17.17,0,0,0-.18.18V-.18a.17.17,0,0,0,.18.18h.9a.17.17,0,0,0,.18-.18v-3.4a1.229,1.229,0,0,1,1.26-1.284,1.494,1.494,0,0,1,.48.072c.12.024.192.012.24-.108l.276-.66A.16.16,0,0,0,28.134-5.784Z",
    transform: "translate(668 978)",
    fill: "#2d3544",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(736.728 961.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1294",
    "data-name": "Group 1294",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174-2",
    "data-name": "Path 1174",
    d: "M58.61,56.1l-6-3v6Z",
    transform: "translate(-42.178 -43.571)",
    fill: "#191c23",
    opacity: 0.25
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagKeysLeftArrow);
export default __webpack_public_path__ + "static/media/tag-keys-left-arrow.60d550ac5334e72b069624e4e4f85fb7.svg";
export { ForwardRef as ReactComponent };